import React from 'react';
import { LiferayProps } from '.';
import './App.css';
import MainView from './components/mainContent/Main';
import { FormProvider } from './components/context/FormContext';
import { LoaderProvider } from './components/context/LoaderContext';

const App:React.FC<LiferayProps> = ({ properties }) => {
  return (
    <>
      <LoaderProvider>
        <FormProvider>
          <MainView properties={properties}/>
        </FormProvider>
      </LoaderProvider>
    </>
  );
}

export default App;